/** Completed onboarding sessions can include apps that are not EHRs. */
const NON_EHR_PROVIDERS = new Set(['fullscript']);

/** Keep unknown providers in the existing EHR path until classified. */
export const isEhrIntegrationProvider = (provider: string | null | undefined): boolean =>
  Boolean(provider) && !NON_EHR_PROVIDERS.has(provider?.trim().toLowerCase() ?? '');
